import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { PrincipalLayouts } from "../../layouts";
import { useCreateLanding } from "../data/landing/hooks";
import { Loading } from "../components/generals/Loading";
import "../components/generals/editor.styles.css";

export const IndividualsListPage = () => {
  const { fetchLandingContent, response, error, isLoading } =
    useCreateLanding();
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    fetchLandingContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (response) {
      setDataLoaded(true);
    }
  }, [response]);

  if (isLoading) return <Loading />;

  return (
    <>
      <PrincipalLayouts>
        {error && (
          <Stack
            height="calc(100vh - 125px)"
            alignItems="center"
            justifyContent="center"
          >
            <img
              src="/logo-faraday-cuadrado.jpg"
              alt="Logo Faraday"
              style={{ width: "50%" }}
            />
          </Stack>
        )}
        {dataLoaded ? (
          <div className="editor-preview">
            <div
              className="preview-item"
              dangerouslySetInnerHTML={{
                __html: response?.response?.htmlString,
              }}
            />
          </div>
        ) : (
          <Loading />
        )}
      </PrincipalLayouts>
    </>
  );
};

export default IndividualsListPage;
